import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Manages authentication state from localStorage and Firestore user data.
 * Extracts auth-related logic from MainLayout.
 *
 * Returns user info, role flags, and profile data.
 */
export function useAuth() {
  const userId = localStorage.getItem('userId');
  const username = localStorage.getItem('username') || 'Misafir';
  const isLoggedIn = !!userId;

  const [isAdmin, setIsAdmin] = useState(false);
  const [isCoach, setIsCoach] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [role, setRole] = useState('student');
  const [coachId, setCoachId] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [xp, setXp] = useState(0);
  const [level, setLevel] = useState(1);
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      try {
        const userRef = doc(db, 'users', userId);
        const snapshot = await getDoc(userRef);

        if (snapshot.exists()) {
          const data = snapshot.data();
          const userRole = data.role || 'student';
          setRole(userRole);
          setIsAdmin(userRole === 'admin');
          setIsCoach(userRole === 'coach');
          setIsPremium(!!data.isPremium);
          setCoachId(data.coachId || null);
          setAvatar(data.avatar || null);
          setXp(data.xp || 0);
          setLevel(data.level || 1);
          setBadges(data.badges || []);
        }
      } catch (err) {
        console.error('useAuth: Error fetching user data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userId]);

  const xpPerLevel = 100;
  const xpProgress = (xp % xpPerLevel) / xpPerLevel * 100;

  return {
    userId,
    username,
    isLoggedIn,
    isAdmin,
    isCoach,
    isPremium,
    role,
    coachId,
    avatar,
    xp,
    level,
    badges,
    xpPerLevel,
    xpProgress,
    loading,
    // Setters for external mutation (e.g., task completion)
    setXp,
    setLevel,
    setBadges,
    setAvatar,
    setIsPremium,
  };
}
